<template>
    <div class="padding-10">
        <a-divider orientation="left">用户管理</a-divider>

        <div class="search-div">
            <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="12">
                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="角色">
                                <a-select v-model="queryParam.role" @change="changeRole">
                                    <a-select-option v-for="item in staticParam.role" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="集团">
                                <group-select-list ref="groupSelect" @changeGroup="changeGroup"></group-select-list>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="场站">
                                <station-select-list ref="stationSelect" @changeStation="changeStation"></station-select-list>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label=" " :colon="false">
                             <span class="table-page-search-submitButtons">
                              <a-button type="primary" @click="initTable">查询</a-button>
                             </span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </div>

        <div class="table-tools-right">
            <a-button-group >
                <a-button  @click="initTable"><i class="fa fa-refresh icon"></i>  刷新</a-button>
                <a-button type="primary" @click="add"><i class="fa fa-plus icon"></i>  新增</a-button>
            </a-button-group>
        </div>
        <a-table :loading="loading"
                 :columns="columns"
                 :dataSource="data"
                 bordered
                 @change="changeOrder"
                 :scroll="{x:  '150%'}"
                 :pagination="pagination"
        >
                   <span slot="id" slot-scope="text, record, index">
                        <template>
                            <span>{{index + 1}}</span>
                        </template>
                  </span>

            <span slot="option" slot-scope="text, record, index">
                        <template>
                            <div class="btn">
                                <span class="badge-success" @click="edit(record)">编辑</span>
                                <a-popconfirm
                                        title="真的要删除该用户吗？"
                                        @confirm="confirm(record)"
                                        okText="是"
                                        cancelText="否"
                                >
                                    <span class="badge-danger" >删除</span>
                                </a-popconfirm>
                                <a-popconfirm
                                        title="真的要重置密码吗？"
                                        @confirm="reset(record)"
                                        okText="是"
                                        cancelText="否"
                                >
                                    <span class="badge-warning" >重置</span>
                                </a-popconfirm>
                            </div>
                        </template>
                  </span>
        </a-table>

        <a-modal title="添加用户" v-model="addModel.visible" @ok="handleOk" :maskClosable="false">
            <div class="search-div">
                <div class="table-page-search-wrapper">
                    <a-form :form="form" layout="inline">
                        <a-row :gutter="12">
                            <a-form-item  label="角色" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-radio-group name="radioGroup" v-model="addModel.roleId" :defaultValue="1">
                                    <a-radio :value="1">管理员</a-radio>
                                    <a-radio :value="2">集团用户</a-radio>
                                    <a-radio :value="3">场站用户</a-radio>
                                </a-radio-group>
                            </a-form-item>

                            <a-form-item v-show="addModel.roleId === 2 || addModel.roleId === 3" label="集团" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <group-select-list :all="false" @changeGroup="changeGroup2"></group-select-list>
                            </a-form-item>

                            <a-form-item v-show="addModel.roleId === 3" label="场站" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <station-select-list :all="false" ref="stationSelectAdd" @changeStation="changeStation2"></station-select-list>
                            </a-form-item>

                            <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['name', { rules: [{ required: true, message: '用户名不能为空' }] }]"/>
                            </a-form-item>
                        </a-row>
                    </a-form>
                </div>
            </div>
        </a-modal>

        <a-modal title="修改用户" v-model="editModel.visible" @ok="handleEditOk" :maskClosable="false">
            <div class="search-div">
                <div class="table-page-search-wrapper">
                    <a-form :form="editForm" layout="inline">
                        <a-row :gutter="12">

                            <a-form-item label="角色" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['roleName']" :disabled="true" />
                            </a-form-item>

                            <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['username', { rules: [{ required: true, message: '用户名不能为空' }] }]" />
                            </a-form-item>

                            <a-form-item v-show="editModel.roleId === 2 || editModel.roleId === 3" label="集团" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <group-select-list ref="groupSelect"  :all="false" @changeGroup="changeGroup3"></group-select-list>
                            </a-form-item>

                            <a-form-item v-show="editModel.roleId === 3" label="场站" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <station-select-list ref="stationSelectEdit" :all="false"  @changeStation="changeStation3"></station-select-list>
                            </a-form-item>

                            <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['name']" />
                            </a-form-item>

                            <a-form-item label="电话" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number :precision="0" :style="{'width': '100%'}" v-decorator="['phone']" />
                            </a-form-item>

                            <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['email']"/>
                            </a-form-item>

                            <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-textarea  v-decorator="['description']" :autosize="{ minRows: 2, maxRows: 6 }" />
                            </a-form-item>
                        </a-row>
                    </a-form>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import moment from "moment"
    import groupSelectList from "../components/common/groupSelectList";
    import stationSelectList from "../components/common/stationSelectList";

    const columns = [
        {
            title: 'id',
            key: 'id',
            dataIndex: 'id',
            sorter: true,
            scopedSlots: {customRender: "id"},
        },
        {
            title: '用户名',
            key: 'username',
            dataIndex: 'username',
            sorter: true
        },

        {
            title: '姓名',
            key: 'name',
            dataIndex: 'name',
            sorter: true
        },
        {
            title: '角色',
            key: 'roleName',
            dataIndex: 'roleName',
            sorter: true
        },
        {
            title: '场站名',
            key: 'powerStationName',
            dataIndex: 'powerStationName',
            sorter: true
        },
        {
            title: '集团名',
            key: 'groupName',
            dataIndex: 'groupName',
            sorter: true,
        },
        {
            title: '电话',
            key: 'phone',
            dataIndex: 'phone',
            sorter: true,
        },
        {
            title: '邮箱',
            key: 'email',
            dataIndex: 'email',
            sorter: true
        },
        {
            title: '描述',
            key: 'description',
            dataIndex: 'description',
            sorter: true
        },
        {
            title: '在线状态',
            key: 'loginStatusName',
            dataIndex: 'loginStatusName',
            sorter: true
        },
        {
            title: '登录次数',
            key: 'loginTimes',
            dataIndex: 'loginTimes',
            sorter: true
        },
        {
            title: '最后上线时间',
            key: 'lastConnTime',
            dataIndex: 'lastConnTime',
            sorter: true
        },
        {
            title: '操作',
            key: 'option',
            dataIndex: 'option',
            sorter: true,
            scopedSlots: {customRender: "option"},
            width: 200,
            fixed: 'right'
        }


    ];
    export default {
        name: "user",
        components:{
            groupSelectList,
            stationSelectList
        },
        data(){
            return {
                labelCol: {
                    span: 4
                },
                columns,
                data: [],
                form: this.$form.createForm(this),
                editForm: this.$form.createForm(this),
                queryParam:{
                    role: 0,
                },
                queryParams:{
                    sortName: 'id',
                    sortOrder: 'asc',
                    page: 1,
                    size: 10
                },
                order: {
                    ascend: 'asc',
                    descend: 'desc'
                },
                loading: false,
                pagination: {
                    total: 0,
                    current: 1,
                    // defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10','20','50','100']
                },
                staticParam:{
                    role: [
                        {
                            id: 0,
                            name: '不限'
                        },
                        {
                            id: 1,
                            name: '管理员'
                        },
                        {
                            id: 2,
                            name: '集团用户'
                        },
                        {
                            id: 3,
                            name: '场站用户'
                        }
                    ]
                },
                addModel:{
                    visible: false,
                    groupId: '',
                    station: '',
                    roleId: 1
                },
                editModel:{
                    visible: false,
                    obj: null,
                    groupId: '',
                    station: '',
                    roleId: 1
                },
                groupId: 0,
                stationId: 0,
            }
        },

        methods:{
            changeGroup(id){
                this.groupId = id;
                this.$refs.stationSelect.loadStation(id);
            },
            changeStation(id){
                this.stationId = id;
                this.initTable();
            },
            async initTable(){
                this.loading = true;
                let result = await this.$http.get(this.$baseURL.findUser({roleId: this.queryParam.role, groupId: this.groupId, powerStationId: this.stationId }, this.queryParams));
                console.log(result)
                this.data = result.list;
                this.pagination.current = result.pageNum;
                this.pagination.total = result.total;
                this.loading = false;

                console.log(this.pagination)
            },

            changeOrder(pagination, filters, sorter){
                console.log(pagination ,sorter)
                this.queryParams.page = pagination.current;
                this.queryParams.sortName = sorter.columnKey ? sorter.columnKey : 'id';
                this.queryParams.sortOrder = sorter.order ? this.order[sorter.order] : 'asc';
                this.initTable()
            },

            changeRole(){
                this.initTable()
            },

            add(){
                this.addModel.visible = true;
                this.$nextTick(()=>{
                    this.form.setFieldsValue({
                        "name": ''
                    })
                })
            },

            handleOk(e){
                e.preventDefault();
                const { form: { validateFields }} = this;
                validateFields(["name"], { force: true }, (err, values) => {
                    let roleId = this.addModel.roleId;
                    if (!err) {
                        if(roleId === 1){
                            let params = { ...values };
                            this.addUser({
                                roleId: roleId,
                                username: params.name
                            });
                        } else if(roleId === 2){
                            let groupId = Number(this.addModel.groupId);
                            if(groupId !== -1 || groupId !== 0){
                                if (!err) {
                                    let params = { ...values };
                                    this.addUser({
                                        roleId: roleId,
                                        groupId: groupId,
                                        username: params.name
                                    })
                                }
                            } else {
                                this.$message.error('请先添加集团');
                            }
                        } else if(roleId === 3){
                            let groupId = Number(this.addModel.groupId);
                            let station = Number(this.addModel.station);
                            if(groupId !== -1 || groupId !== 0){
                                if(station !== -1 || station !== 0){
                                    if (!err) {
                                        let params = { ...values };
                                        this.addUser({
                                            roleId: roleId,
                                            groupId: groupId,
                                            powerStationId: station,
                                            username: params.name
                                        })
                                    }
                                } else {
                                    this.$message.error('请先添加场站');
                                }
                            } else {
                                this.$message.error('请先添加集团');
                            }
                        }
                    }
                })
            },
            async addUser(obj){
                await this.$http.postJson(this.$baseURL.manageUser(), obj);
                this.$Utils.showSuccess({title: '添加成功'});
                this.addModel.visible = false;
                this.initTable();
            },
            /**********编辑**********/

            edit(data){
                console.log(data);
                this.editModel.visible = true;
                this.editModel.obj = data;
                this.editModel.roleId = data.roleId;
                this.$nextTick(()=>{
                    this.$refs.groupSelect.updateSelectId(data)
                    this.$refs.stationSelect.updateSelectId(data)
                    this.editForm.setFieldsValue({
                        'roleName': data.roleName,
                        "username": data.username,
                        "name": data.name,
                        "phone": data.phone,
                        "email": data.email,
                        "description": data.description
                    })
                })

            },

            handleEditOk(e){
                e.preventDefault();
                const { editForm: { validateFields }} = this;
                validateFields(["username", "name", "phone", "email", "description"], { force: true }, (err, values) => {
                    let roleId = this.editModel.roleId;
                    if (!err) {
                        if(roleId === 1){
                            let params = { ...values };
                            params.roleId = roleId;
                            this.eddUser(params);
                        } else if(roleId === 2){
                            let groupId = Number(this.editModel.groupId);
                            if(groupId !== -1 || groupId !== 0){
                                if (!err) {
                                    let params = { ...values };
                                    params.roleId = roleId;
                                    params.groupId = groupId;
                                    this.eddUser(params)
                                }
                            } else {
                                this.$message.error('请先添加集团');
                            }
                        } else if(roleId === 3){
                            let groupId = Number(this.editModel.groupId);
                            let station = Number(this.editModel.station);
                            if(groupId !== -1 || groupId !== 0){
                                if(station !== -1 || station !== 0){
                                    if (!err) {
                                        let params = { ...values };
                                        params.roleId = roleId;
                                        params.groupId = groupId;
                                        params.powerStationId = station;
                                        this.eddUser(params)
                                    }
                                } else {
                                    this.$message.error('请先添加场站');
                                }
                            } else {
                                this.$message.error('请先添加集团');
                            }
                        }
                    }

                })
            },
            async eddUser(obj){
                obj.id = this.editModel.obj.id;
                await this.$http.putJson(this.$baseURL.manageUser(), obj);
                this.$Utils.showSuccess({title: '修改成功'});
                this.editModel.visible = false;
                this.initTable();
            },
            /************删除*************/
            async confirm(data){
                //console.log(data)
                await this.$http.deleteJson(this.$baseURL.userDeleteById(data.id));
                this.$Utils.showSuccess({title: '删除成功'});
                this.initTable();
            },

            /***********重置**********/
            async reset(data){
                await this.$http.putJson(this.$baseURL.manageUser(), {id: data.id,
                    password: "e10adc3949ba59abbe56e057f20f883e"});
                this.$Utils.showSuccess({title: '重置成功'});
            },
            changeGroup2(id){
                this.addModel.groupId = id;
                this.$refs.stationSelectAdd.loadStation(id);
            },
            changeGroup3(id){
                this.editModel.groupId = id;
                this.$refs.stationSelectEdit.loadStation(id);

            },
            changeStation2(id){
                this.addModel.station = id;
            },
            changeStation3(id){
                this.editModel.station = id;
            },


        },
        computed:{
            wrapperCol(){
                return {span: 24 - this.labelCol.span};
            }
        }
    }
</script>

<style lang="less" scoped>

    .table-tools-right {
        display: flex;
        flex-direction: row-reverse;
        margin-bottom: 15px;
    }

    .icon{
        margin-right: 5px;
    }
    .btn {
        span{
            display: inline-block;
            padding: 3px 10px;
            margin-right: 5px;
            &:hover{
                cursor: pointer;
            }
        }
        .badge-success:hover {
            background: #1890ff;
        }

        .badge-danger:hover{
            background: #ed3543;
        }

    }
</style>
